import { Component } from '@angular/core';

@Component({
  selector: 'empathy-carousel-rating-form',
  templateUrl: 'carousel-rating-form.component.html',
  styleUrls: ['./carousel-rating-form.component.scss']
})
export class CarouselRatingFormComponent {}
